function makeObserverCallback(onResize) {
    var lastKnownHeight = 0;
    return function onHeightChange(entries) {
        var rootData = entries[0];
        var height = Math.round(rootData.contentRect.height);
        if (height === lastKnownHeight) {
            return;
        }
        lastKnownHeight = height;
        onResize({ height: height });
    };
}
export function observeContentResize(root, onResize) {
    if (window && !!window.ResizeObserver) {
        var observerCallback = makeObserverCallback(onResize);
        var resizeObserver = new ResizeObserver(observerCallback);
        resizeObserver.observe(root);
    }
    else {
        console.warn('Browser doesn\'t implements ResizeObserver API');
    }
}
